import React from 'react'
import Layout from '../components/layout'
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import {refreshActivityTimer} from '../components/timeout'
import {Link} from 'react-router'
import {authenticateWithPin} from '../store'
import {browserHistory} from 'react-router'
import PageviewGA from '../components/pageview-ga'

class Body extends React.Component {

    constructor() {
        super();
        this.state = {pin: ""}
    }

    componentWillMount() {
        if( this.props.store.current_user.is_account_locked ) browserHistory.replace("/account-locked")
    }

    checkForEnter(e) {
        let pin = e.target.value
        if (pin.length === 4 && e.key === 'Enter') {
            this.refs.pin.blur()
            this.login(e)
        }

    }

    validatePinEntry(e) {
        refreshActivityTimer()
        if ( isNaN(e.target.value) ) return
        let pin = e.target.value
        this.setState( {pin})
    }

    login(e) {
        authenticateWithPin( this.state.pin, (data) => {
            if( data.http_status === 423 ) {
                browserHistory.push("/account-locked")
            }
            else if( data.http_status === 200 ) {
                refreshActivityTimer()
            }

        })
    }

    componentDidMount() {
        this.refs.pin.focus()
    }

    render() {
        const login = this.props.store.login

        if ( login.show_spinner ) {
            return (
                <div id="main_content" className="spinner flex layout-column scrollable layout-align-center-center">
                    <CircularProgress size={80} thickness={7} />
                </div>
            )
        }

        return(
            <div className="page-margin pin layout-row layout-align-center-start">
                <div className="layout-column layout-align-center">
                <h1>Please enter your PIN</h1>
                    <div>
                        <input name="pin" ref="pin" type="password" maxLength="4" minLength="4" size="4" value={this.state.pin} onKeyPress={(e) => this.checkForEnter(e)} onChange={(e) => this.validatePinEntry(e)}/>
                    </div>
                    <br/>
                    { login.ready && login.http_status === 412 ?
                        <span className="error">Please try again</span>
                            : <br/>
                    }
                    <br/>
                    <RaisedButton disabled={this.state.pin.length !== 4} fullWidth={true} label="LOGIN" primary={true} onClick={() => this.login()}/>
                    <br/>
                    <br/>
                    <Link to="/reset-pin">I've forgotten my PIN</Link>
                </div>
            </div>

        )
    }
}


export default class extends React.Component {
    render() {
        return (
            <div className="layout-row flex">
                <PageviewGA hash="enter_your_pin"/>
                <Layout title="Login"
                        showAppBarActions={false}
                        {...this.props}
                        ready={true}
                        body={Body}>
                </Layout>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/enter_your_pin.js